<template>
  <v-row class="mt-5">
    <v-col cols="12">
      <search-table
        placeholder="Search Assignments"
        @change="params.search = $event"
        @clear="clearSearch"
        @submit="getList"
      />
    </v-col>

    <v-col cols="12">
      <base-data-table
        class="mb-10"
        gap="mid"
        :headers="headers"
        :items="items"
        :items-per-page="params.itemsPerPage"
        :loading="loading"
        :page="params.page"
      >
        <template v-slot:[`header.action`]>
          <total-entries-count
            :items-per-page="params.itemsPerPage"
            :page="params.page"
            :total="total"
          />
        </template>

        <template v-slot:[`item.assignment.title`]="{ item }">
          <p>
            {{
              item.assignment.title
                | formatAssignmentTitle(item.assignment.short_title)
            }}
          </p>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            color="primary"
            link
            small
            text
            :to="{
              name: 'UserAssignments',
              params: { userId: item.user.uuid },
            }"
          >
            View Assignments
          </v-btn>
        </template>
        <template v-slot:footer>
          <base-paginator
            :items-per-page="params.itemsPerPage"
            :page="params.page"
            :total="total"
            @change="params.page = $event"
          />
        </template>
      </base-data-table>
    </v-col>
  </v-row>
</template>

<script>
import TotalEntriesCount from '@/components/_shared/TotalEntriesCount'
import SearchTable from '@/components/_shared/SearchTable'
import filters from '@/utils/mixins/filters'
import { EVALUATION_STATUS } from '@/utils/constants'

export default {
  name: 'ChallengedEvalautions',

  components: { SearchTable, TotalEntriesCount },

  mixins: [filters],

  data: () => ({
    params: {
      page: 1,
      itemsPerPage: 10,
      search: '',
    },

    headers: [
      {
        text: "User's Name",
        sortable: false,
        value: 'user.full_name',
      },
      {
        text: 'Assignment Name',
        sortable: false,
        value: 'assignment.title',
      },
      {
        text: "professor's Name",
        sortable: false,
        value: 'professor',
      },
      {
        text: '',
        sortable: false,
        value: 'action',
        align: 'end',
      },
    ],

    items: [],
    total: 0,
    loading: false,
  }),

  watch: {
    'params.page'() {
      this.getList()
    },
  },

  mounted() {
    this.getList()
  },

  methods: {
    clearSearch() {
      this.params.search = ''
      this.getList()
    },

    async getList() {
      this.loading = true

      try {
        const { search, page } = this.params
        const res = await this.$api.assignments.listAssignments({
          params: {
            evaluation_status: EVALUATION_STATUS.CHALLENGED,
            search,
            page: search ? 1 : page,
            fields: ['professor'],
          },
        })
        this.items = res.data.data
        this.total = res.data.total
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
